import React from 'react';
import VaultSidebar from '../../components/vault/VaultSidebar';
import VaultHeader from '../../components/vault/VaultHeader';
import AuditDashboard from '../../components/admin/AuditDashboard';

const AuditDashboardPage: React.FC = () => {
    return (
        <div className="h-screen flex overflow-hidden bg-gray-100">
            <VaultSidebar />
            <div className="flex flex-col flex-1 overflow-hidden">
                <VaultHeader />
                <main className="flex-1 overflow-y-auto bg-gray-50 dark:bg-gray-900">
                        <AuditDashboard />
                </main>
            </div>
        </div>
    );
};

export default AuditDashboardPage;
